import { render } from "./g-error2-page.vue?vue&type=template&id=5fee8f12&ts=true"
import script from "./g-error2-page.vue?vue&type=script&lang=tsx"
export * from "./g-error2-page.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__